import { Status } from 'components';

const ErrorStatus = () => <Status type="error" />;

export default ErrorStatus;
